module.exports = __webpack_public_path__ + "static/img/205_TO8_2120.6bb082f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/205_TO8_2120.jpg
// module id = GiJ6
// module chunks = 0